import { memo, FC } from 'react';
import { Box, Grid, GridItem } from '@chakra-ui/react';

import { TextWithTooltip } from 'components/molecules/TextWithTooltip/TextWithTooltip';
import { Contract } from 'types/contract';

type Props = {
  /** 契約情報情報 */
  item: Contract;
  /** 行クリックイベントのハンドラ */
  handleContractClick: () => void;
};

export const ContractListItem: FC<Props> = memo(
  ({ item, handleContractClick }) => (
    <Box
      m={0}
      h="40px"
      w="100%"
      textAlign="start"
      color="secondaryList.item.color"
      border="none"
      backgroundColor="secondaryList.item.bgColor"
      _hover={{
        background: 'gray.100',
      }}
      _active={{
        background: 'gray.200',
      }}
      borderBottom="1px"
      borderBottomColor="secondaryList.item.borderColor"
    >
      <Box
        as="button"
        m={0}
        h="100%"
        w="100%"
        textAlign="start"
        cursor="pointer"
        onClick={handleContractClick}
      >
        <Grid
          templateColumns="2fr 3fr 7fr 2fr 3fr 3fr"
          gap={0}
          justifyItems="start"
          alignItems="center"
        >
          <GridItem justifySelf="center" pl="20px" pr="20px">
            <TextWithTooltip text={item.id.toString()} />
          </GridItem>
          <GridItem justifySelf="center" pl="20px" pr="20px">
            <TextWithTooltip text={item.menuId.toString()} />
          </GridItem>
          <GridItem pl="20px">
            <TextWithTooltip
              text={item.menuName}
              textMaxWidth="300px"
              visibleTooltip
              tooltipMaxWidth="400px"
            />
          </GridItem>
          <GridItem pl="20px">
            <TextWithTooltip text={item.valid ? '有効' : '無効'} />
          </GridItem>
          <GridItem pl="20px">
            <TextWithTooltip text={item.startDate} />
          </GridItem>
          <GridItem pl="20px">
            <TextWithTooltip text={item.endDate} />
          </GridItem>
        </Grid>
      </Box>
    </Box>
  ),
);
